export default {
  title: {
    base: 'for yourself and your patients.',
    keyword: 'Add convenience',
  },
  description: 'Healistic provides an easy-to-use web interface for doctors, allowing you to issue private e-prescriptions to your patients and have them directly fulfilled via our pharmacy and logistics network – all in a few clicks.',
  extra: 'Medication range includes refrigerated drugs, controlled drugs, and injectables.',
};
